import React from "react";
import { Link, useLocation } from "react-router-dom";
import { useMsal, useIsAuthenticated } from "@azure/msal-react";
import { loginRequest } from "../auth/msalConfig";

export const Navbar: React.FC = () => {
  const { instance, accounts } = useMsal();
  const isAuthenticated = useIsAuthenticated();
  const location = useLocation();

    const handleLogin = () => {
    instance.loginRedirect(loginRequest).catch(console.error);
  };

  const handleLogout = () => {
    instance.logoutRedirect().catch(console.error);
  };

  const isActive = (path: string) =>
    location.pathname === path ? "text-white bg-white/10" : "text-blue-100 hover:text-white hover:bg-white/5";

  return (
    <nav className="bg-brand-800 shadow-lg">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          {/* Logo & Brand */}
          <div className="flex items-center gap-8">
            <Link to="/" className="flex items-center gap-3">
              <div className="w-8 h-8 bg-blue-500 rounded-lg flex items-center justify-center text-white font-bold text-sm">
                AT
              </div>
              <div>
                <span className="text-white font-semibold text-sm">Administración de Terrenos</span>
                <span className="block text-blue-200 text-xs">Gobierno de Puerto Rico</span>
              </div>
            </Link>

            {/* Nav Links */}
            <div className="flex items-center gap-1">
              <Link to="/arrendamiento" className={`px-3 py-2 rounded-md text-sm font-medium transition ${isActive("/arrendamiento")}`}>
                Arrendamiento
              </Link>
              {isAuthenticated && (
                <>
                  <Link to="/parcelas" className={`px-3 py-2 rounded-md text-sm font-medium transition ${isActive("/parcelas")}`}>
                    Parcelas
                  </Link>
                  <Link to="/contratos" className={`px-3 py-2 rounded-md text-sm font-medium transition ${isActive("/contratos")}`}>
                    Contratos
                  </Link>
                  <Link to="/dashboard" className={`px-3 py-2 rounded-md text-sm font-medium transition ${isActive("/dashboard")}`}>
                    Dashboard
                  </Link>
                  <Link to="/inspeccion" className={`px-3 py-2 rounded-md text-sm font-medium transition ${isActive("/inspeccion")}`}>
                    Inspección
                  </Link>
                  <Link to="/leases" className={`px-3 py-2 rounded-md text-sm font-medium transition ${isActive("/leases")}`}>
                    Leases
                  </Link>
                </>
              )}
            </div>
          </div>

          {/* Auth */}
          <div className="flex items-center gap-4">
            {isAuthenticated ? (
              <div className="flex items-center gap-3">
                <span className="text-blue-200 text-sm">
                  {accounts[0]?.name ?? accounts[0]?.username}
                </span>
                <button
                  onClick={handleLogout}
                  className="px-3 py-1.5 bg-white/10 text-white text-sm rounded-md hover:bg-white/20 transition"
                >
                  Cerrar Sesión
                </button>
              </div>
            ) : (
              <button
                onClick={handleLogin}
                className="px-4 py-1.5 bg-blue-500 text-white text-sm font-medium rounded-md hover:bg-blue-400 transition"
              >
                Iniciar Sesión
              </button>
            )}
          </div>
        </div>
      </div>
    </nav>
  );
};
